import logo from '../../assets/img/logo.svg';

import './logo.css';

function Logo() {
    return <img className='invite-logo' src={logo} alt="logo Saboreando"/>;
}

export default Logo;